import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AppsReviewCard from './AppsReviewCard';
import Typography from "@material-ui/core/Typography";
import DocIcon from '../../icons/DocIcon';
import VideoIcon from '../../icons/VideoIcon';
import RateIcon from '../../icons/RateIcon';
import OutsourcingIcon from '../../icons/OutsourcingIcon';
import ChevronIcon from '../../icons/ChevronIcon';
import IconButton from '@material-ui/core/IconButton';
import { Link, useParams, useHistory } from "react-router-dom";
import CardManager from '../CardManager';
import CardPromotion from '../CardPromotion';
import translate from '../../other/translate.json'
import SwipeableViews from 'react-swipeable-views';
import axios from 'axios';
import Skeleton from '@material-ui/lab/Skeleton';
import SkeletonReviewContent from '../Skeleton/SkeletonReviewContent';
import VersionPlanDrawer from './VersionPlanDrawer';
import config from '../../other/config';
const { serverAPI } = config;

export default function AppsReviewContent(props) {
  let history = useHistory()
  const classes = useStyles();
  const theme = useTheme();
  const [wide, setWide] = useState(false);
  const [filter, setFilter] = React.useState(false);
  const [valueAction, setValueAction] = React.useState(0);
  const [valueAction2, setValueAction2] = React.useState(1);
  const [loading, setloading] = React.useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [dynamicsDesc, setDynamicsDesc] = useState('');
  const [dynamicsVersions, setDynamicsVersions] = useState([]);
  // const handleChangeIndex = (index) => {

  //   setValueAction(index);
  // };

  // const handleStrockList = (event, index) => {
  //   setSelectedIndex(index);
  // };
  const click_first = () => {
    window.scrollTo({ top: 0 })
  }
  const toggleFilterDrawer = () => {
    setFilter(!filter);
  };

  const setValueAction_ = (increment) => {
    if (true === increment) {
      if (valueAction + 1 < actions.length - 1) {
        setValueAction(valueAction + 1)
        setValueAction2(valueAction + 2)
      } else if (valueAction + 1 === actions.length - 1) {
        setValueAction(actions.length - 1)
        setValueAction2(0)
      } else {
        setValueAction(0)
        setValueAction2(1)
      }
    } else {
      if (valueAction === 0) {
        setValueAction2(valueAction)
        setValueAction(actions.length - 1)
      } else {
        setValueAction2(valueAction)
        setValueAction(valueAction - 1)
      }
      // } else if (valueAction + 1 === actions.length - 1) {

      //   setValueAction2(actions.length - 1)
      //   setValueAction(0)
      // } else {
      //   setValueAction2(0)
      //   setValueAction(1)
      // }
    }
  }

  const [bankinfo, setBankinfo] = useState([]);
  const [directions, setDirections] = useState([]);
  // const [directions2, setDirections2] = useState([]); // Костыль
  const [actions, setActions] = useState([]);
  let inCu = props.userCollection.CatalogCu || props.userCollection.inCu;

  let { IsRu } = props
  let lang = IsRu ? 'Ru' : 'En'
  let { bank } = useParams();


  // let url = 'cftbank' 
  // useEffect(() => {
  // 	if (/cloud/gmi.test(history.location.pathname)) { 	setSelectedIndex(4) }
  // 	if (/applications/gmi.test(history.location.pathname)) { setSelectedIndex(3) }
  // 	if (/products/gmi.test(history.location.pathname)) { setSelectedIndex(2) }
  // 	if (/solutions/gmi.test(history.location.pathname)) { setSelectedIndex(1) }
  // }, [history.location.pathname])

  useEffect(() => {
    let didCancel = false;
    async function fetchData() {
      setloading(true)
      const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${bank}/3/${lang}`)
      const _directions = await axios.get(`${serverAPI}/bn/${lang}?systema=${bank}&archive=${_bankinfo.data[0].isArchive}`)
      const _actions = await axios.get(`${serverAPI}/actions/${bank}/${lang}?inCu=${inCu}`)
      if (!didCancel) {

        if (_bankinfo && _bankinfo.data) {
          setDynamicsDesc(_bankinfo.data[0][`VersionInfo`])
          setDynamicsVersions(JSON.parse(_bankinfo.data[0][`Versions`]))
          setBankinfo(_bankinfo.data[0])
          setDirections(_directions.data)
          setloading(false)
          setActions(_actions.data)
        }
      }
    }
    fetchData();
    return () => {
      didCancel = true;
    }
  }, [bank]);

  function SpecialOffers() {
    let dateNow = new Date();
    let actionActual = [];

    actions.map((item, index) => {
      if (new Date(item.DateEndSale.split('.')[2] + ',' + item.DateEndSale.split('.')[1] + ',' + item.DateEndSale.split('.')[0]) > dateNow) {
        actionActual.push(item)
      }
    });

    if (actionActual.length > 0) {
      return (
        <Grid item xs={12} className={classes.block} style={{ marginTop: 99 }}>
          <Grid item container justify="space-between" alignItems="center" xs={12}>
            <Grid item>
              <Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ textAlign: 'left' }}>
                {translate.Words[`SpecialOffers${lang}`]}
              </Typography>
            </Grid>

            {actionActual.length > 1 ?
              <Grid item>
                <IconButton onClick={() => setValueAction_(false)} style={{ backgroundColor: '#FFF', transform: 'rotate(180deg)', marginRight: 12, padding: 15 }}>
                  <ChevronIcon fill={'#BCBBD0'} />
                </IconButton>

                <IconButton onClick={() => setValueAction_(true)} style={{ backgroundColor: '#FFF', padding: 15 }}>
                  <ChevronIcon fill={'#BCBBD0'} />
                </IconButton>
              </Grid>
              : null
            }
          </Grid>

          <SwipeableViews axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}>
            {
              actions.length > 0
                ?
                <Grid
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="flex-start"
                  style={{ marginTop: 17 }}
                >
                  {
                    window.innerWidth > 1705
                      ?
                      <React.Fragment>
                        <CardPromotion
                          lang={lang}
                          title={actions[valueAction][`Title`]}
                          info={actions[valueAction][`BriefDescription`]}
                          start={actions[valueAction][`DateStartSale`] || ''}
                          end={actions[valueAction][`DateEndSale`] || ''}
                          link={actions[valueAction][`link`]}
                          bgcolor={'paper'}
                        />

                        {
                          actions.length > 1
                            ?
                            <CardPromotion
                              lang={lang}
                              title={actions[valueAction2][`Title`]}
                              info={actions[valueAction2][`BriefDescription`]}
                              start={actions[valueAction2][`DateStartSale`] || ''}
                              end={actions[valueAction2][`DateEndSale`] || ''}
                              link={actions[valueAction2][`link`]}
                              bgcolor={'paper'}
                            />
                            :
                            ''
                        }
                      </React.Fragment>
                      :
                      <CardPromotion
                        lang={lang}
                        title={actions[valueAction][`Title`]}
                        info={actions[valueAction][`BriefDescription`]}
                        start={actions[valueAction][`DateStartSale`] || ''}
                        link={actions[valueAction][`link`]}
                        end={actions[valueAction][`DateEndSale`] || ''}
                        bgcolor={'paper'}
                      />
                  }
                </Grid>
                // ))
                :
                ''
            }
          </SwipeableViews>
        </Grid>
      )
    }
  }

  return (
    <React.Fragment>
      <Grid container style={{ marginTop: 50 }}>
        {loading === true
          ?
          <Grid item container style={{ marginBottom: 129 }}>
            <SkeletonReviewContent />
          </Grid>
          :
          <Grid container direction="row" justify="space-between">
            <Grid item className={classes.serviceDescription}>
              {
                bankinfo
                  ?
                  <Typography component="p" className={classes.Body1} dangerouslySetInnerHTML={{ __html: bankinfo[`HTMLContent`] }} />
                  :
                  ''
              }
            </Grid>

            <Grid item className={classes.SideActions}>
              {
                IsRu && bankinfo && bankinfo.AboutPath && bankinfo.AboutPath.length > 4
                  ?
                  <a className={classes.link} href={`${serverAPI}/${bankinfo.HashCode}/about/${bankinfo.AboutPath}`} rel="noopener noreferrer" target="_blank">
                    <Grid item container direction="row">
                      <DocIcon fill={'#BCBBD0'} />

                      <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                        Информация по каталогу
                      </Typography>
                    </Grid>
                  </a>
                  :
                  ''
              }

              {
                IsRu && bankinfo && bankinfo.VideoPath && bankinfo.VideoPath.length > 4
                  ?
                  <a className={classes.link} href={`${serverAPI}/${bankinfo.HashCode}/video/${bankinfo.VideoPath}`} rel="noopener noreferrer" target="_blank">
                    <Grid item container direction="row" style={{ marginTop: 20 }}>
                      <VideoIcon fill={'#BCBBD0'} />

                      <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                        Видео презентация
                      </Typography>
                    </Grid>
                  </a>
                  :
                  ''
              }

              {
                bankinfo.Outsourcing && bankinfo.Outsourcing.length > 4
                  ?
                  <a className={classes.link} href={bankinfo.Outsourcing} rel="noopener noreferrer" target="_blank">
                    <Grid item container direction="row" style={{ marginTop: 20 }}>
                      <RateIcon fill={'#BCBBD0'} />
                      <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                        {translate.Words[`Outsourcing_${lang}`]}
                      </Typography>
                    </Grid>
                  </a>
                  :
                  ''

              }

              {
                bankinfo.Tariff && bankinfo.Tariff.length > 4
                  ?
                  <a className={classes.link} href={bankinfo.Tariff} rel="noopener noreferrer" target="_blank">
                    <Grid item container direction="row" style={{ marginTop: 20 }}>
                      <OutsourcingIcon fill={'#BCBBD0'} />
                      <Typography component="p" className={classes.Body1} style={{ marginLeft: 30 }}>
                        {translate.Words[`PricePlans_${lang}`]}
                      </Typography>
                    </Grid>
                  </a>
                  :
                  ''
              }

              {
                ((dynamicsVersions.length > 0 || dynamicsDesc !== '') && dynamicsVersions.some(item => item.publishVers && Number(item.publishVers) > 0))
                  ?
                  <VersionPlanDrawer
                    lang={lang}
                    dynamicsDesc={dynamicsDesc}
                    dynamicsVersions={dynamicsVersions}
                  />
                  :
                  null
              }
            </Grid>
          </Grid>
        }

        {directions && directions.length > 0 ?
          < Grid item container alignItems="center" style={{ marginTop: 63, marginBottom: 26 }}>
            <Typography className={classes.Title2}>{translate.Words[`ApplicationsbyBusinessDirections${lang}`]}</Typography>
          </Grid> : ''
        }
        <Grid container spacing={3} style={{ marginTop: -14, overflowY: 'auto' }}>
          {
            directions && directions.length > 0
              ?
              directions.map((item, index) => {
                return (
                  <Grid item style={{ width: 336 }} key={`${item.ID_BN}_grid_key`}
                    onClick={() => click_first()}
                  >

                    <Link to={`/applications/${item.URL}/applist?filt=false&direction=${item.ID_BN}`} style={{ textDecoration: 'none' }} >
                      <AppsReviewCard
                        key={`appcardkey_${item.ID_BN}`}
                        data={item}
                        wide={wide}
                        IsRu={IsRu}

                      />
                    </Link>
                  </Grid>
                )
              })
              : loading ?

                <React.Fragment>
                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>

                  <Grid item>
                    <Skeleton animation="wave" variant="rect" width={312} height={205} style={{ borderRadius: 16 }} />
                  </Grid>
                </React.Fragment>
                : ''
          }
          {/* {bank === 'cftbank' ? directions2.map((item, index) => {
            return (
              <Grid item style={{ width: 336 }} key={`${item.ID_BN}_grid_key`}>
                <Link to={`/applications/ss/applist?filt=false&direction=${item.ID_BN}`} style={{ textDecoration: 'none' }} >
                  <AppsReviewCard
                    key={`appcardkey_${item.ID_BN}`}
                    data={item}
                    wide={wide}
                    IsRu={IsRu}

                  />
                </Link>
              </Grid>
            )
          }) : <></>
          } */}
        </Grid>

        {bankinfo?.DocumentPath?.split(';').map((item) => {
          if (item) {
            return (
              <Grid item style={{ paddingTop: 24 }}>
                <a href={`/${bankinfo.HashCode}/document/${item}`} rel="noopener noreferrer" target="_blank" style={{ textDecoration: "none" }}>
                  <Grid item className={classes.attachContainer}>
                    <DocIcon fill={'#BCBBD0'} />

                    <Typography component="p" className={classes.descriptionAttach} >
                      {item.slice(0, -4)}
                    </Typography>
                  </Grid>
                </a>
              </Grid>
            )
          }
        })}
      </Grid>

      {SpecialOffers()}

      {
        bankinfo[`Managers${lang}`]
          ?
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="flex-start"
          >
            <Grid item container className={classes.block}>
              <Typography variant="body2" color="textSecondary" component="p" className={classes.contentHeader} style={{ textAlign: 'center', width: '100%' }}>
                {translate.Words[`ReadytoAnswerYourQuestions${lang}`]}:
              </Typography>

              <Grid
                item
                container
                direction="row"
                justify="center"
                alignItems="flex-start"
                spacing={3}
                style={{ marginTop: 40 }}
              >
                {
                  bankinfo[`Managers${lang}`] ? bankinfo[`Managers${lang}`].split(';').map((item, index) => (
                    <Grid item>
                      <CardManager data={item} />
                    </Grid>
                  ))
                    :
                    ''
                }
              </Grid>
            </Grid>
          </Grid>
          :
          ''
      }
    </React.Fragment >
  );
}

const useStyles = makeStyles(theme => ({
  contentHeader: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '28px',
    lineHeight: '40px',
    textAlign: 'center',
    color: '#000000'
  },

  paper: {
    padding: theme.spacing(3),
    textAlign: "center",
    color: theme.palette.text.secondary,
    boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
    borderRadius: theme.spacing(2)
  },

  footer: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    padding: '36px 0'
  },

  tHeader: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    fontWeight: 400
  },

  Title2: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '28px',
    lineHeight: '40px',
    color: '#000000'
  },

  Body1: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#24262A',

    '& * > a': {
      color: '#24262A !important',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',

      '&:hover': {
        color: '#2050FF !important',
        textDecoration: 'none',
        borderBottom: '1px solid #2050FF',
      },

      '& > span': {
        color: 'inherit !important',
        textDecoration: 'none !important',

        '& > font': {
          color: 'inherit !important',
          textDecoration: 'none !important',

          '&:hover': {
            color: 'inherit !important',
            textDecoration: 'none !important',
          }
        }
      }
    },
  },

  link: {
    textDecoration: 'none'
  },

  SideActions: {
    minWidth: 246,
    padding: '12px 26px',
    // width: 313,
    marginTop: 17,

    [theme.breakpoints.down(1032)]: {
      padding: 0,
      marginBottom: 60,
    }
  },

  serviceDescription: {
    padding: '11px 0px',
    maxWidth: 865,

    [theme.breakpoints.between(1032, 1702)]: {
      maxWidth: 670,
    },

    [theme.breakpoints.down(1032)]: {
      maxWidth: '100%'
    },
  },

  attachContainer: {
    display: 'flex',
    marginTop: 10
  },

  descriptionAttach: {
    color: '#24262A',
    fontSize: '16px',
    fontFamily: 'Cera CY',
    margin: 'auto 30px auto 15px',
    borderBottom: '1px solid #24262A',

    '&:hover': {
      color: '#2050FF',
      borderBottom: '1px solid #2050FF',
    },
  },
}));